<main class="container-geral">
  <section class="cabecalho justify-content-between">
    <div class="titulo-cabecalho d-flex align-items-center">
      <h1 class="titulo fonte-DM-Sans me-3">AGView Connect</h1>
      <span class="frota-equipamento">
        {{ equipamentoFiltrado?.vc_frota ? '(' + equipamentoFiltrado?.vc_frota + ')' : '' }}
      </span>
    </div>

    <div class="filtros-cabecalho col-md-7 d-flex justify-content-end gap-3 align-items-end">
      <app-filtro-clientes (carregarCliente)="buscarEquipamentos($event)"
        [classeContainer]="'largura-ajustada-apontamentos'" #selectClientes>
      </app-filtro-clientes>

      <app-filtro-equipamentos [clienteId]="clienteId" (carregarEquipamento)="selecionarEquipamento($event)"
        (obterEquipamentos)="obterEquipamentos($event)" [tipoComunicador]="TIPO_COMUNICADOR">
      </app-filtro-equipamentos>

      <button type="button" class="botao-filtrar fonte-DM-Sans" [disabled]="!podeFiltrarInformacoes"
        (click)="onFiltrar()">
        {{ "COMPONENTS.AGVIEW_CONNECT.FILTER_BUTTON" | transloco }}
      </button>
    </div>
  </section>

  <div *ngIf="!carregandoConfiguracoes && !configuracoesCadastradas" class="empty-state">
    <p class="empty-state-message">{{ 'COMPONENTS.AGVIEW_CONNECT.EMPTY_STATE' | transloco }}</p>
  </div>

  <div class="d-flex justify-content-center align-items-center h-90"
    *ngIf="!carregandoConfiguracoes && configuracoesCadastradas">
    <app-tela></app-tela>
  </div>

  <div *ngIf="carregandoConfiguracoes && !configuracoesCadastradas" class="loading-container">
    <div class="spinner"></div>
  </div>

  <button *ngIf="mostrarBadgeEnviosPendentes" (click)="abrirEnviosPendentes()" class="badge-pendentes">
    <img class="icone" width="30" height="30" src="assets/agview-connect/info.svg" />
    {{ "COMPONENTS.AGVIEW_CONNECT.PENDING_UPLOADS" | transloco }}
  </button>
</main>
